import { createSlice } from "@reduxjs/toolkit"

import {
  getCustomPackagingList,
  uploadNewCustomBoxImage,
} from "./customPackagingThunkApi"

const initialState: any = {
  loading: "idle",
  customListFetching: "idle",
  myCustomPackagingList: [],
  totalCustomPackagingCount: 0,
}

export const customPackagingSlice = createSlice({
  name: "customPackagingService",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCustomPackagingList.pending, (state) => {
      state.customListFetching = "pending"
    })
    builder.addCase(getCustomPackagingList.fulfilled, (state, action) => {
      const { records, totalCount } = action.payload
      state.customListFetching = "succeeded"
      state.myCustomPackagingList = records || []
      state.totalCustomPackagingCount = totalCount ?? 0
    })
    builder.addCase(getCustomPackagingList.rejected, (state) => {
      state.customListFetching = "failed"
    })
    builder.addCase(uploadNewCustomBoxImage.pending, (state) => {
      state.loading = "pending"
    })
    builder.addCase(uploadNewCustomBoxImage.fulfilled, (state) => {
      state.loading = "succeeded"
    })
    builder.addCase(uploadNewCustomBoxImage.rejected, (state) => {
      state.loading = "failed"
    })
  },
})
